export default function HelpIcon({
  width = 20,
  height = 20,
  color = "#AEAFB0",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5ZM10 14.5C9.44771 14.5 9 14.9477 9 15.5C9 16.0523 9.44771 16.5 10 16.5C10.5523 16.5 11 16.0523 11 15.5C11 14.9477 10.5523 14.5 10 14.5ZM10 3.75C7.92893 3.75 6.25 5.42893 6.25 7.5C6.25 7.91421 6.58579 8.25 7 8.25C7.41421 8.25 7.75 7.91421 7.75 7.5C7.75 6.25736 8.75736 5.25 10 5.25C11.2426 5.25 12.25 6.25736 12.25 7.5C12.25 8.48356 11.6183 9.32161 10.7363 9.62695C10.0577 9.86197 9.25 10.4976 9.25 11.5V12.5C9.25 12.9142 9.58579 13.25 10 13.25C10.4142 13.25 10.75 12.9142 10.75 12.5V11.5C10.75 11.4441 10.7707 11.3708 10.8516 11.2812C10.9364 11.1873 11.07 11.0985 11.2275 11.0439C12.6947 10.5358 13.75 9.14225 13.75 7.5C13.75 5.42893 12.0711 3.75 10 3.75Z"
        fill={color}
      />
    </svg>
  );
}
